import { UiSchema } from '@rjsf/utils'
import { AnyObject } from '@feedyou/utils'
import { BotFeatures } from '@feedyou/schema'

import { useBaseStepUiSchema } from '../../../../../../features/schema'

export function useFormUiSchema(formData: AnyObject, sdkFeatures: BotFeatures[] = []): UiSchema {
  return useBaseStepUiSchema(sdkFeatures)
}
